<template>
  <div :class="['items-center justify-center', isMobile ? 'column' : 'row']">
    <img
      v-if="img"
      :class="{ 'q-mb-xl': isMobile }"
      :src="img"
      alt="claim img"
      :style="isMobile ? 'width: 200px;' : 'margin-right: 150px; width: 320px;'"
    />
    <div :class="{ 'q-my-md full-width': isMobile }">
      <p
        :class="[
          'text-weight-medium',
          isMobile ? 'text-h6 text-center' : 'text-h4'
        ]"
      >
        Make a claim
      </p>
      <p :class="['q-mt-sm q-mb-lg', { 'text-center': isMobile }]">
        Have your receipt handy? Claim now!
      </p>

      <SAIBtn
        :class="{ 'full-width': isMobile }"
        padding="15px xl"
        no-caps
        :disable="disable"
        @click="$emit('start:claim')"
      >
        <p class="text-weight-medium">Start Claim</p>
      </SAIBtn>
      <SAIBtn
        :class="{ 'full-width q-mt-md': isMobile, 'q-ml-md': !isMobile }"
        padding="15px xl"
        no-caps
        outline
        v-if="canShowEvClaim"
        :disable="disable"
        @click="$emit('start:evclaim')"
      >
        <p class="text-weight-medium">Start EV Claim</p>
      </SAIBtn>
      <SAIBtn
        :class="{ 'full-width q-mt-md': isMobile, 'q-ml-md': !isMobile }"
        padding="15px xl"
        no-caps
        outline
        v-if="canShowHistory"
        @click="$emit('view:history')"
      >
        <p class="text-weight-medium">View claims history</p>
      </SAIBtn>
    </div>
  </div>
</template>

<script>
import { SAIBtn } from 'ecx.saigon.ui.common';

export default {
  name: 'StartClaim',
  props: {
    img: String,
    isMobile: Boolean,
    canShowHistory: Boolean,
    canShowEvClaim: Boolean,
    disable: Boolean
  },
  components: {
    SAIBtn
  }
};
</script>
